export { default } from './BuyingsOverview';
